import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";

var SvgAlignLeft = function SvgAlignLeft(props) {
  return _jsx("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: _jsx("path", {
      fill: props.color || '#909090',
      fillRule: "evenodd",
      d: "M2 4c0-.552.506-1 1.13-1h10.74c.624 0 1.13.448 1.13 1s-.506 1-1.13 1H3.13C2.506 5 2 4.552 2 4ZM2 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 8a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    })
  }));
};

export default SvgAlignLeft;